// extracted by mini-css-extract-plugin
export var divider = "_qi-0";
export var systemMessage = "_qi-1";